var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTripleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1876 20C18.1284 20 18.0716 19.977 18.0299 19.9362L10.1577 12.2338C10.0707 12.1487 9.92931 12.1487 9.84232 12.2338L1.97012 19.9362C1.92835 19.977 1.87161 20 1.81244 20L0.223033 20C0.0249227 20 -0.0744754 19.7667 0.0653563 19.6298L9.84232 10.0638C9.92931 9.97872 10.0707 9.97872 10.1577 10.0638L19.9346 19.6298C20.0745 19.7667 19.9751 20 19.777 20L18.1876 20Z",
    fill: "#FFE500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1876 15C18.1284 15 18.0716 14.977 18.0299 14.9362L10.1577 7.23382C10.0707 7.14871 9.92931 7.14871 9.84232 7.23382L1.97012 14.9362C1.92835 14.977 1.87161 15 1.81244 15L0.223033 15C0.0249227 15 -0.0744754 14.7667 0.0653563 14.6298L9.84232 5.06384C9.92931 4.97872 10.0707 4.97872 10.1577 5.06384L19.9346 14.6298C20.0745 14.7667 19.9751 15 19.777 15L18.1876 15Z",
    fill: "#FFE500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1876 10C18.1284 10 18.0716 9.97703 18.0299 9.93616L10.1577 2.23382C10.0707 2.14871 9.92931 2.14871 9.84232 2.23382L1.97012 9.93616C1.92835 9.97703 1.87161 10 1.81244 10L0.223033 10C0.0249227 10 -0.0744754 9.76665 0.0653563 9.62984L9.84232 0.063835C9.92931 -0.021278 10.0707 -0.021278 10.1577 0.063835L19.9346 9.62984C20.0745 9.76665 19.9751 10 19.777 10L18.1876 10Z",
    fill: "#FFE500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTripleUp);
export default __webpack_public_path__ + "static/media/arrow-triple-up.a30091f239179ed8bb62251f08687554.svg";
export { ForwardRef as ReactComponent };